





import { Component, Vue } from 'vue-property-decorator';

@Component
export default class CompMarkupWrapper extends Vue {
  get getStyle() {
    return this.$route.path.includes('/new/blog')
      ? {}
      : { 'max-width': '1130px' };
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/markup/Wrapper.vue